import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { jsPDF } from 'jspdf';
import { AppService } from 'src/app/app.service';
import * as XLSX from 'xlsx';
import { HttpService } from '../../services/http.service';
import { take } from 'rxjs';
import { TableService } from '../../services/tableService/table.service';

@Component({
  selector: 'app-export-pdf-ltl',
  standalone: false,
  templateUrl: './export-pdf-ltl.component.html',
  styleUrl: './export-pdf-ltl.component.scss',
})
export class ExportPdfLtlComponent implements OnChanges {
  @ViewChild('ltlcontainer') ltlcontainer: ElementRef | any;
  @Input() data: any;
  @Input() raData: any;
  @Input() type: any;
  fileType: any;
  private spread: any;
  destinCol: any;
  dbDataSource: any;
  tableData: any;
  chargesList: any;
  countryListArr: any;
  mauntList: any;
  tableType: any;
  subscription: any;
  displayedCol: any = [
    'from',
    'to',
    '100-200',
    '201-300',
    '301-400',
    '401-500',
    '501-750',
    '751-1000',
    '1001-1250',
    '1251-1500',
    '1501-1750',
    '1751-2000',
    '2001-2500',
    '2501-3000',
    '3001-3500',
    '3501-4000',
    '4001-5000',
    '5001-6000',
    '6001-7000',
    '7001-8000',
    '8001-9000',
    '9001-10000',
    '10001-12500',
    '12501-15000',
    '15001-20000',
    '20001-23999',
    '24000-+',
  ];
  agreemntData: any;
  effectiveDate: any;
  constructor(
    public appService: AppService,
    public httpService: HttpService,
    public tableService: TableService
  ) {
    // setTimeout(() => {
    //   this.subscription = this.appService.exportConversionEmitter.pipe(take(1)).subscribe((evt:any) =>{
    //     this.displayedCol=[]
    //     this.dbDataSource=[]
    //     if(evt.type === 'ltl'){
    //       this.tableType = "ltl"
    //       this.dbDataSource = evt.data;
    //       this.displayedCol = Object.keys(this.dbDataSource[0])
    //       this.tableData = this.appService.rateDateSource[this.appService.selectedItem]
    //       this.deleteIconUpdate();
    //     }
    //   });
    //   this.appService.rateExportEmit.subscribe((evt:any) =>{
    //     if(evt.type === "ltl" && evt.format === 'PDF'){
    //       this.onSavePDF(this.ltlcontainer?.nativeElement);
    //     }
    //     else if(evt.type === "ltl" && evt.format === 'Excel'){
    //       this.onSaveExcel(this.ltlcontainer?.nativeElement);
    //     }
    //     this.subscription.unsubscribe();
    //   })
    // }, 0);
  }

  deleteIconUpdate() {
    this.destinCol = [];
    if (this.tableType === 'fixed') {
      this.displayedCol.forEach((col: any) => {
        if (['service'].includes(col)) {
          if (!this.destinCol.includes('Distance'))
            this.destinCol.push('Distance');
        } else {
          if (!this.destinCol.includes(col.split('-')[0])) {
            this.destinCol.push(col.split('-')[0]);
          }
        }
      });
    } else {
      this.displayedCol.forEach((col: any) => {
        if (['from', 'to'].includes(col)) {
          if (!this.destinCol.includes('Distance'))
            this.destinCol.push('Distance');
        } else {
          if (!this.destinCol.includes(col.split('-')[0])) {
            this.destinCol.push(col.split('-')[0]);
          }
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']?.currentValue) {
      let bindData = changes['data'].currentValue;
      this.chargesList = bindData.charge;
      this.data = bindData.data;
      this.tableData = bindData.name;
      this.dbDataSource = this.data;
      this.effectiveDate = bindData.effectiveDate;
      // this.displayedCol = Object.keys(this.dbDataSource[0])
      // this.tableData = this.appService.rateDateSource[this.appService.selectedItem]
    }
    if (changes['raData']?.currentValue) {
      this.agreemntData = changes['raData']?.currentValue;
    }
    if (changes['type']?.currentValue) {
      this.fileType = changes['type']?.currentValue;
    }
  }
  findCountryName(i: number): string {
    return i
      ? this.appService.countryListArr.find((item: any) => item.CountryID === i)
          .CountryName
      : '';
  }

  onSavePDF(element: any) {
    let content = element;
    let doc = new jsPDF('p', 'pt', 'A4', false);
    const contentHeight = content?.offsetHeight;
    const contentWidth = content?.offsetWidth;
    const pdfWidth = doc.internal.pageSize.getWidth();
    const pdfHeight = doc.internal.pageSize.getHeight();
    const scale = 1; // Math.min(pdfWidth / contentWidth, pdfHeight / contentHeight);
    let name = this.tableData?.RateTableName + '.pdf';

    const options = {
      x: 10,
      y: 10,
      width: contentWidth * scale,
      height: contentHeight * scale,
      scale,
      callback: function (doc_e: {
        setFontSize: (arg0: number) => void;
        save: (arg0: string) => void;
      }) {
        doc_e.save(name);
      },
      html2canvas: { scale: 0.4 },
    };
    doc.html(content, options);
  }

  formatElementData(val: any) {
    return Number(val) ? '' + Number(val).toFixed(2) : null;
  }

  onSaveExcel(element: any) {
    const content = element;
    const workbook = XLSX.utils.table_to_book(content, { sheet: 'Sheet1' });
    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const fileName = this.tableData?.RateTableName + '.xlsx';

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(data);
    link.download = fileName;
    link.click();
  }

  styleUpdate() {
    let matRow =
      this.ltlcontainer.nativeElement.querySelectorAll('.mat-mdc-row');
    let matHeader = this.ltlcontainer.nativeElement.querySelectorAll(
      '.mat-mdc-header-row'
    );
    let fontValue =
      this.ltlcontainer.nativeElement.querySelectorAll('.update-font');
    fontValue.forEach((component: any) => {
      component.style.fontSize = `${this.tableService.newFontSize * 0.55}px`;
    });
    matRow.forEach((component: any) => {
      component.style.height = `${this.tableService.newHeight + 2}px`;
    });
    matHeader.forEach((component: any) => {
      component.style.height = `${this.tableService.newHeight + 4}px`;
    });
  }
}
